import { radioClasses } from '@mui/joy/Radio';
import type { StyleOverrides, Theme } from '@mui/joy/styles';
import type { RadioOwnerState, RadioSlot } from '@mui/joy/Radio';

export const getRadioStyleOverrides = (): StyleOverrides<RadioSlot, RadioOwnerState, Theme> => {
  return {
    root: () => [
      {
        // remove extra height
        '--Radio-size': 0,
        height: 'min-content',
      },
    ],
    radio: () => [
      {
        background: 'transparent',
      },
    ],
    icon: () => [{}],
    action: () => [
      {
        // focus ring applied to radio element via cva
        [`&.${radioClasses.focusVisible}`]: {
          outline: 'none',
        },
      },
    ],
    label: () => [{}],
  };
};
